<script>
    import Step from './Step.svelte'

    import { Container, ScrollAnchor } from '@/components'

    const steps = [
        {
            description: 'Погружаемся в задачу: общаемся<br/> с вами, изучаем особенности<br/> вашего бизнеса и готовим<br/> персональное предложение',
            corner: 'right-top',
            desktop: {
                width: 386,
                height: 290,
                top: 143,
                left: 100
            },
            adaptive: {
                top: 125,
            }
        },
        {
            description: 'Получаем от вас доступ к 1С:ЗУП<br/> или базу данных пользователей<br/> и синхронизируем данные с<br/> EmployeeGate по заданным<br/> параметрам',
            corner: 'left-bottom',
            desktop: {
                width: 386,
                height: 274,
                top: 224,
                right: 100
            },
            adaptive: {
                top: 556,
                right: 0,
            }
        },
        {
            description: 'Настраиваем цепочки<br/> согласования и статусную<br/> модель бизнес-процессов',
            corner: 'right-bottom',
            desktop: {
                width: 281,
                height: 306,
                top: 585,
                left: 200
            },
            adaptive: {
                top: 922,
                left: 100
            }
        },
        {
            description: 'Меняем пользовательский<br/> интерфейс под вашу<br/> компанию',
            desktop: {
                width: 282,
                height: 322,
                top: 738,
                right: 200
            },
            adaptive: {
                top: 1276,
                right: 0
            }
        },
        {
            description: 'Обучим HR-специалистов<br/> работать с порталом и дадим<br/> понятные инструкции в формате<br/> скринкастов',
            corner: 'right-bottom',
            desktop: {
                width: 384,
                height: 262,
                top: 1180,
                left: 'calc(100% / 2 - 384px / 2)'
            },
            adaptive: {
                top: 1700,
            }
        }
    ]
</script>

<Container>
    <ScrollAnchor id="how-to" />
    <h2 class="title">Внедрим и настроим бесперебойную работу<br/> EmployeeGate за 5 шагов</h2>

    <div class="wrapper scroll-element">
        <div class="line" />

        {#each steps as data, i }
            <Step num={i+1} {data} />
        {/each}
    </div>

    <div slot="background" class="background" />
</Container>

<style lang="scss">
    .title {
        margin-top: 117px;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
    }

    .wrapper {
        position: relative;
        height: 1700px;

        .line {
            position: absolute;
            top: 75px;
            right: 250px;
            width: 578px;
            height: 1137px;
            background-image: url('../img/steps-line.png');
            background-repeat: no-repeat;
            background-size: 100%;
        }
    }

    .background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url('../img/steps-background.jpg');
        background-repeat: no-repeat;
        background-size: cover;
    }

    @media (max-width: 834px) {
        .wrapper {
            height: 2418px;

            .line {
                background-image: url('../img/steps-line-adaptive.png');
                right: 0;
                top: 200px;
                width: 550px;
                height: 1558px;
                background-size: auto 100%;
            }
        }
    }

    @media (max-width: 420px) {
        .wrapper {
            height: 2025px;
            margin-top: 100px;

            .line {
                background-image: url('../img/steps-line-mobile.png');
                right: calc(50% - 124px / 2);
                top: 150px;
                width: 124px;
                height: 1422px;
                background-size: auto 100%;
            }
        }
    }
</style>